export default "__VITE_ASSET__DjNa8tYM__"